<svg
  width="28"
  height="29"
  viewBox="0 0 28 29"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.97027 23.562C12.7693 24.8038 16.103 24.7363 18.9578 23.0881C23.7008 20.3497 25.3259 14.2848 22.5875 9.5417L22.2959 9.03651M5.41082 19.4585C2.67241 14.7154 4.2975 8.6505 9.04057 5.91209C11.8954 4.26386 15.2291 4.19641 18.0281 5.43817M2.9082 19.5561L6.0956 20.4102L6.94965 17.2228M21.049 11.7768L21.903 8.58943L25.0904 9.44349"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
